<template>
    <!-- Waiting section when we are pulling Edge Report -->
    <div v-if="showProgress" class="flex flex-col items-center justify-center space-y-4">
        <div class="w-64 h-2 bg-gray-300 rounded-full relative overflow-hidden">
            <div 
                class="absolute top-0 left-0 h-full transition-all duration-700" 
                :style="{ width: progressPercentage + '%' }"
                style="background-color: rgb(34, 197, 94)">
            </div>
        </div>
        
        <div class="text-center text-gray-600">
            <span>{{ currentText }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "WaitingProgressBar",
    props: {
        showProgress: {
            type: Boolean,
            default: false
        },
        progressDuration: {
            type: Number,
            default: 60
        },
        progressTexts: {
            type: Array,
            default: () => [
                "Pulling data...",
                "Checking account details...",
                "Validating income source...",
                "Cross-checking the details...",
                "Comparing the data...",
                "Processing the information...",
                "Finalizing the report...",
                "Almost there...",
                "Finishing up...",
                "Done!"
            ]
        }
    },
    data() {
        return {
            currentText: "",
            progressPercentage: 0,
            progressInterval: null,
            textInterval: null
        }
    },
    methods: {
        startProgress() {
            this.resetProgress();
            let index = 0;
            let stepTime = this.progressDuration / this.progressTexts.length; // How often to change text

            this.currentText = this.progressTexts[index];

            this.textInterval = setInterval(() => {
                index = (index + 1) % this.progressTexts.length;
                this.currentText = this.progressTexts[index];
            }, stepTime * 1000);

            let stepProgress = 100 / (this.progressDuration * 4); // Update progress every 250ms
            this.progressInterval = setInterval(() => {
                if (this.progressPercentage >= 100) {
                    clearInterval(this.progressInterval);
                    clearInterval(this.textInterval);
                    this.currentText = "Done!";
                    this.$emit('progress-complete');
                } else {
                    this.progressPercentage += stepProgress;
                }
            }, 250);
        },
        resetProgress() {
            this.progressPercentage = 0;
            clearInterval(this.progressInterval);
            clearInterval(this.textInterval);
        }
    },
    watch: {
        showProgress: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.startProgress();
                } else {
                    this.resetProgress();
                }
            }
        }
    }
};
</script>